import { css } from 'styled-components';

export const defaultBorderRadiusCSS = css`
  border-radius: 12px;
`;
